import React from "react";
import { Chip, Tooltip } from "@mui/material";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import { markingTimeValue } from "../helper/markingTime";

const EXPLANATION =
    "Predicted from the marking file's vectors: the marking length at each group's speed, the jumps at the jump speed and the scanner's delays per vector. Not measured.";

/**
 * "Predicted marking time 4 min 12 s", next to a marking-file download or a
 * remote-marking panel. ``value`` is the backend's ``{seconds, text}``
 * payload or a number of seconds; nothing is rendered without a value.
 * ``label`` names what the time is for when a page shows several
 * ("All plates", "Plate 2").
 */
export default function MarkingTimeChip({ value, label = "Predicted marking time", size = "small", sx }) {
    const payload = markingTimeValue(value);
    if (!payload) return null;
    return (
        <Tooltip title={EXPLANATION} arrow>
            <Chip
                size={size}
                variant="outlined"
                icon={<TimerOutlinedIcon />}
                label={`${label} ${payload.text}`}
                data-testid="marking-time-chip"
                sx={{ fontWeight: 600, ...sx }}
            />
        </Tooltip>
    );
}
